import { type Room } from '../../waiting-room';
import {
  MembershipType,
  type NodeRoomV2,
  type RoomForPatient,
  type RoomV2,
} from '../room.types';

export const mapOgRoomToV2 = (room: Room): RoomV2 => ({
  id: room.id.toString(),
  membershipType: room.isPersonal ? MembershipType.Owner : MembershipType.Guest,
  slug: room.slug,
  passcode: room.passcode,
  isPasscodeEnabled: Boolean(room.usePasscode),
  cameraOff: Boolean(room.cameraOff),
  owner: null,
  sharedRoomDisplayName: null,
});

export const mapOgRoomToNodeV2 = (room: Room): NodeRoomV2 => ({
  node: mapOgRoomToV2(room),
});

export const mapOgRoomToV2ForPatient = (room?: Room): RoomForPatient | null => {
  if (!room) {
    return null;
  }

  return {
    ...room,
    id: room.id.toString(),
    legacyId: Number(room.id),
    usePasscode: Boolean(room.usePasscode),
    isPersonal: Boolean(room.isPersonal),
    usePasscodeStoredValue: Boolean(room.usePasscodeStoredValue),
    shouldRedirect: Boolean(room.shouldRedirect),
    checkInPhotoCapture: Boolean(room.checkInPhotoCapture),
    roomAdmin: {
      ...room.roomAdmin,
      id: room.roomAdmin.id.toString(),
    },
  };
};
